import { defaultSortOption } from "@/lib/ListingFilters"

// Removes /artworks and /staff-picks since
// it's not important for query building
function removeNamespace(pathname) {
  const newPath = pathname
    .replace("/artworks", "")
    .replace("/staff-picks", "")
    .replace("/exclusives", "")
    .replace("/featured-art", "")

  return newPath.split("/")
}

function valuePresent(paths, name, callback) {
  if (!paths.includes(name)) return []

  const values = paths[paths.indexOf(name) + 1]

  return callback(values)
}

// Gets value of broken down paths
// Eg.
//
// paths = ["collection", "pop+aboriginal", "medium", "acrylic"]
// valueOf(paths, "collection") = ["pop", "aboriginal"]
// valueOf(paths, "medium") = ["acrylic"]
function valueOf(paths, name) {
  return valuePresent(paths, name, (value) => {
    return value?.includes("+") ? value.split("+") : [value]
  })
}

function rangeOfInt(paths, name) {
  return valuePresent(paths, name, (value) => value.split("-").map((val) => parseInt(val)))
}

// Search term only has one value
// Destructure from valueOf and make `-` into space
//
// Eg "artem-bry" -> "artem bry"
function searchTerm(terms) {
  const term = terms[0] || ""
  const decoded = decodeURI(term).replace(/-/g, " ")

  return decoded
}

export default function ({ pathname, search }) {
  let filters = {}
  const paths = removeNamespace(pathname)
  let searchParams = new URLSearchParams(search)
  const defaultOption = defaultSortOption()

  filters = { term: searchTerm(valueOf(paths, "search")), ...filters }
  filters = { collections: valueOf(paths, "collection"), ...filters }
  filters = { competitions: valueOf(paths, "competitions"), ...filters }
  filters = { art_styles: valueOf(paths, "style"), ...filters }
  filters = { mediums: valueOf(paths, "medium"), ...filters }
  filters = { locations: valueOf(paths, "location"), ...filters }
  filters = { prices: valueOf(paths, "price"), ...filters }
  filters = { price_range: rangeOfInt(paths, "price-range"), ...filters }
  filters = { sizes: valueOf(paths, "size"), ...filters }
  filters = { width: rangeOfInt(paths, "width"), ...filters }
  filters = { height: rangeOfInt(paths, "height"), ...filters }
  filters = { colors: valueOf(paths, "colour"), ...filters }
  filters = { orientations: valueOf(paths, "orientation"), ...filters }
  filters = { artwork_statuses: valueOf(paths, "artwork_statuses"), ...filters }
  filters = { sort: valueOf(paths, "sort")[0] || defaultOption, ...filters }
  filters = { page: searchParams.get("page"), ...filters }
  filters = { per: valueOf(paths, "per")[0], ...filters }
  filters = { competition_category_ids: valueOf(paths, "prize-categories"), ...filters }
  filters = { competition_finalist_hashids: valueOf(paths, "finalists"), ...filters }
  filters = { case_study: valueOf(paths, "case-study")[0], ...filters }
  if (paths.includes("hang")) filters = { ready_to_hang: "ready_to_hang", ...filters }
  if (paths.includes("sold")) filters = { availability: "all", ...filters }
  if (paths.includes("follow")) filters = { from_followeds: "from_followeds", ...filters }

  if (pathname.includes("staff-picks")) filters = { featured: true, ...filters }
  if (pathname.includes("exclusives")) filters = { exclusive: true, ...filters }
  if (pathname.includes("featured-art")) filters = { boosted: true, ...filters }

  return filters
}

function URLSearchTerm(path) {
  return searchTerm(valueOf(removeNamespace(path), "search"))
}

export { URLSearchTerm }
